// Normalise une chaîne pour une recherche insensible aux accents et à la casse.
export function normalizeForSearch(s: string | null | undefined): string {
  return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
}
